import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import { ToastProvider } from '@/context/ToastContext'
import { SystemConfigProvider } from '@/context/SystemConfigContext'
import { TownProvider } from '@/context/TownContext'

function App() {
  return (
    <SystemConfigProvider>
      <ToastProvider>
        <TownProvider>
          <Suspense
            fallback={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100vh',
                  fontSize: '18px',
                  color: '#666',
                }}
              >
                読み込み中...
              </div>
            }
          >
            <RouterProvider router={router} />
          </Suspense>
        </TownProvider>
      </ToastProvider>
    </SystemConfigProvider>
  )
}

export default App

